// @ts-nocheck
// Store Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import buttonModule, { CmsButton, OwnProps } from "@store/Overrides/Widgets/Basic/Button";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isPunchOutSession: getIsPunchOutSession(state),
    isDisabled: getCurrentCartState(state).isLoading || state.context.isUpdatingCart,
});

const mapDispatchToProps = { cancelPunchOut };

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const CancelPunchOutButton = ({ isPunchOutSession, isDisabled, cancelPunchOut, ...widgetProps }: Props) => {
    if (!isPunchOutSession) {
        return null;
    }

    return (
        <CmsButton
            {...widgetProps}
            fields={{
                ...widgetProps.fields,
                label: widgetProps.fields.label || translate("Cancel PunchOut"),
            }}
            buttonProps={{
                type: "button",
                disabled: isDisabled,
                onClick: () => cancelPunchOut(),
                "data-test-selector": "cancelPunchOutButton",
            }}
        />
    );
};

const widgetModule: WidgetModule<Bunzl.BunzlDefinition> = {
    component: connect(mapStateToProps, mapDispatchToProps)(CancelPunchOutButton),
    definition: {
        group: "Common",
        displayName: "Cancel PunchOut Button",
        icon: buttonModule.definition.icon,
        fieldDefinitions: buttonModule.definition.fieldDefinitions
            ?.filter(field => field.name !== "link" && field.name !== "openInNewWindow")
            .map(field => {
                const definition = { ...field };
                if (definition.name === "label" && definition.editorTemplate === "TextField") {
                    definition.defaultValue = "Cancel PunchOut";
                }
                if (definition.name === "variant" && definition.editorTemplate === "DropDownField") {
                    definition.defaultValue = "tertiary";
                }
                if (definition.name === "alignment" && definition.editorTemplate === "DropDownField") {
                    definition.defaultValue = "flex-start";
                }
                return definition;
            }),
    },
};

export default widgetModule;
